import React from 'react'
import { useNavigate } from "react-router-dom";
import { useFormSubmit } from "../../../hook/useFormSubmit";
import { handleErrorResponse } from "../../../utils/handleErrorResponse";
import { Button, Container, Grid, Typography } from "@mui/material";
import { LineBreaker } from "../../../atomicComponent/AtomicComponents";
import LandscapeCard from "../../../atomicComponent/LandscapeCard/LandscapeCard";
import { useFetchAllPopups } from "../../../data/swrs/popup";
import { popupApis } from '../../../data/api/popupApi';
import { formatDate } from './util/formatDate';

const Popups = () => {
	const { data: Popups, error, mutate } = useFetchAllPopups();
	const navigate = useNavigate();

	const handleEditPopup = id => {
		navigate(`/AdminDashboard/edit-Popup/${id}`);
	};

	const handleAddPopup = () => {
		navigate('/AdminDashboard/add-Popup');
	};

	const handleDeletePopup = useFormSubmit(async (id) => {
		const response = await popupApis.deletePopupApi(id); 
		if (handleErrorResponse(response)) return;
		mutate();
	});

	const renderButtons = popup => {
		return [
			{
				title: 'Edit',
				onClick: () => handleEditPopup(popup._id),
				backgroundColor: '#9b92f4'
			},
			{
				title: 'Delete',
				onClick: () => handleDeletePopup(popup._id),
				backgroundColor: '#ff0000'
			}
		];
	};

	return (
		<Container>
			<Grid container spacing={2}>
				<Grid item xs={8}>
					<Typography variant="h4">Popups List</Typography>
				</Grid>
				<Grid item xs={4}>
					<Button variant="outlined" onClick={() => handleAddPopup()}>
						Add Popup
					</Button>
				</Grid>
			</Grid>
			<LineBreaker />
			{error && <p>Error fetching Popups: {error.message}</p>}
			{Popups &&
				Popups.data.map(popup => (
					<React.Fragment key={popup.id}>
						<LandscapeCard
							image={popup.thumbnailLink}
							buttons={renderButtons(popup)}
							infoElement={renderInfoElement(popup)}
						/>
						<LineBreaker />
					</React.Fragment>
				))}
		</Container>
	);
};

const renderInfoElement = (Popup) => {
  return (
    <>
      <h2>{Popup?.headerText}</h2>
      <p>Start Date: {formatDate(Popup?.startDate)}</p>
      <p>End Date: {formatDate(Popup?.endDate)}</p>
      {Popup?.isActive && <p style={{ color: 'green' }}>Active Popup</p>}
    </>
  );
};



export default Popups;
